import React, { useState } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import { useNavigate } from "react-router-dom";
import { BsPencilSquare } from "react-icons/bs";

const AdhocVendorView = () => {
   const navigate = useNavigate();

   const [isChecked, setIsChecked] = useState({}); // State to manage toggle

   const toggleSwitch = () => {
      setIsChecked(isChecked ? (isChecked = true) : (isChecked = false)); // Toggle the state
   };
   const columns = [
      {
         name: "Customer Name",
         selector: (row) => row.customerName,
         sortable: true,
      },
      {
         name: "Origin",
         selector: (row) => row.originName,
         sortable: true,
      },
      {
         name: "Destination",
         selector: (row) => row.destinationName,
         sortable: true,
      },
      {
         name: "Lane Name",
         selector: (row) => row.dob,
      },
      {
         name: "Vehicle Type",
         selector: (row) => row.payrollType,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => row.action,
      },
   ];

   const data = [
      {
         id: 1,
         customerName: "customer 1",
         originName: "Origin 1",
         destinationName: "Destination 3",
         dob: "Lane 1",
         payrollType: "20ft",
         action: (
            <>
               <button
                  className="btn mx-2"
                  onClick={() => navigate("/helper-master/add-form")}
               >
                  <BsPencilSquare
                     className="text-primary"
                     style={{ height: "1.5rem", width: "1.5rem" }}
                  />
               </button>
               <CustomToggleSwitch
                  checked={isChecked}
                  onChange={toggleSwitch}
                  id="helper1"
               />
            </>
         ),
      },
      {
         id: 2,
         customerName: "customer 2",
         originName: "Origin 2",
         destinationName: "Destination 2",
         dob: "Lane 2",
         payrollType: "22ft",
         action: (
            <>
               <button
                  className="btn btn-primary mx-2"
                  onClick={() => navigate("/helper-master/add-form")}
               >
                  Edit
               </button>
               <CustomToggleSwitch
                  checked={isChecked}
                  onChange={toggleSwitch}
                  id="helper2"
               />
            </>
         ),
      },
      {
         id: 3,
         customerName: "customer 3",
         originName: "Origin 3",
         destinationName: "Destination 3",
         dob: "Lane 3",
         payrollType: "24ft",
         action: (
            <>
               <button
                  className="btn btn-primary mx-2"
                  onClick={() => navigate("/helper-master/add-form")}
               >
                  Edit
               </button>
               <CustomToggleSwitch
                  checked={isChecked}
                  onChange={toggleSwitch}
                  id="helper3"
               />
            </>
         ),
      },
   ];

   const [records, setRecords] = useState(data);

   const handleFilter = (e) => {
      const searchText = e?.target?.value?.toLowerCase();
      const newData = data.filter((row) => {
         return (
            row?.customerName?.toLowerCase()?.includes(searchText) ||
            row?.originName?.toLowerCase()?.includes(searchText) ||
            row?.destinationName?.toLowerCase()?.includes(searchText) ||
            row?.dob?.toLowerCase()?.includes(searchText) ||
            row?.payrollType?.toLowerCase()?.includes(searchText)
         );
      });
      setRecords(newData);
   };
   return (
      <div>
         <BodyHeader title="View AdHoc Vendor" />
         <div className=" d-flex justify-content-end">
            <CustomInput
               inputType="text"
               placeholder="Search..."
               id="search"
               onChange={(e) => handleFilter(e)}
            />
         </div>
         <CustomTable columns={columns} data={records} />
      </div>
   );
};

export default AdhocVendorView;
